<template>
  <v-tabs
      :v-model="current_item"
      :color="$store.state.achievement.side_color"
      icons-and-text
      left>
    <v-tab v-for="tab in list_tabs"
           :key="tab.tab"
           @click="setCurrentItemTab(tab.tab)"
           :class="tab.text">
      {{tab.name}}
      <v-icon small>{{tab.icon}}</v-icon>
    </v-tab>
  </v-tabs>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "HeaderTabAdmin",

  data() {
    return {
      list_tabs: [
        {
          name: 'Настройка достижений',
          icon: 'fa fa-cogs',
          text: 'text-caption',
          tab: 'SettingAchievements',
        },
        {
          name: 'Список портфолио',
          icon: 'fa fa-briefcase',
          text: 'text-caption',
          tab: 'ListPortfolios',
        },
      ]
    }
  },

  computed: {
    ...mapState({
      current_item: state => state.achievement_type.current_item_tab,
    }),

  },

  methods: {
    ...mapMutations({
      setCurrentItemTab: "achievement_tuning/setCurrentItemTab",
    }),
  },
}
</script>

<style scoped>

</style>